import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextAreaComponent } from './input-text-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';

@NgModule({
  declarations: [InputTextAreaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    InputNumberModule,
    InputTextareaModule,
    ButtonModule,
    RippleModule,
  ],
  exports: [InputTextAreaComponent],
})
export class InputTextAreaModule {}
